<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <gofix-card class="mb-0 heig-frame-child" fullContent>
                        <!-- gofix-default-table -->
                        <gofix-table
                            :settings="tableConfig"
                            :table-items="tableItems"
                            @load-items="getTableData"
                            ref="gofixTable">
                            <template slot="gofix_table:start_date" slot-scope="row">
                                {{row.item.start_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:end_date" slot-scope="row">
                                {{row.item.end_date | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY")}}
                            </template>
                            <template slot="gofix_table:created_at" slot-scope="row">
                                {{row.item.created_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:updated_at" slot-scope="row">
                                {{row.item.updated_at | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")}}
                            </template>
                            <template slot="gofix_table:include_email" slot-scope="row">
                                <template v-if="row.item.include_email == true">Yes</template>
                                <template v-if="row.item.include_email != true">No</template>
                            </template>
                            <template slot="gofix_table:attachments" slot-scope="row">
                                <div v-if="row.item.attachments !== null && row.item.attachments.length > 0" class="attachmentsColumn" style="padding-left: 0;" @click.stop="doThisImages(row.item.attachments)">
                                    <div v-for="(attachment,index) in  row.item.attachments" :key="index">
                                        <b-button @click="previewFile(attachment)"  class="mr-3 clientPrintIcon"  v-b-tooltip.hover size="sm"><i class="icon-cloud-download icons" ></i></b-button>
                                    </div>
                                </div>
                                <div v-if="row.item.attachments !== null && row.item.attachments.length ==0">
                                </div>
                            </template>
                        </gofix-table>
                    </gofix-card>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    import { filters } from '@/_filterVar.js'
    import { mapGetters } from 'vuex';
    import ViewerImage from '../plugins/ViewerImage.vue';
    export default {
        name: 'nlt-report-list',
        data () {
            let filter = JSON.parse(JSON.stringify(filters['nlt_report_list']));
            return {
                tableConfig:{
                    name: 'nlt-report-list',
                    controls:{
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false,
                        delete:false,
                        create: false
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                    fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                isActive: 1,
                                isFilter: false,
                                with:100,
                                thStyle: "width:100px",
                                sorting: true,
                            },
                            {
                                key: 'start_date',
                                label: 'Start Date',
                                isActive: 1,
                                isFilter: false,
                                with:150,
                                thStyle: "width:150px",
                                sorting: false,
                            },
                            {
                                key: 'end_date',
                                label: 'End Date',
                                isActive: 1,
                                isFilter: false,
                                with:150,
                                thStyle: "width:150px",
                                sorting: false,
                            },
                            {
                                key: 'include_email',
                                label: 'Include Email Performance',
                                isActive: 1,
                                isFilter: false,
                                with:100,
                                thStyle: "width:100px",
                                sorting: false,
                            },
                            {
                                key: 'created_at',
                                label: 'Created Date',
                                isActive: 1,
                                isFilter: true,
                                with:200,
                                thStyle: "width:200px",
                                sorting: true,
                            },
                            {
                                key: 'updated_at',
                                label: 'Updated Date',
                                isActive: 1,
                                isFilter: true,
                                with:200,
                                thStyle: "width:200px",
                                sorting: true,
                            },
                            {
                                key: 'status',
                                label: 'Status',
                                isActive: 1,
                                isFilter: true,
                                with:200,
                                thStyle: "width:200px",
                                sorting: true,
                            },
                            {
                                key: 'created_by_name',
                                label: 'Created By',
                                isActive: 1,
                                isFilter: true,
                                with:200,
                                thStyle: "width:200px",
                                sorting: true,
                            },
                            {
                                key: 'attachments',
                                label: 'Download',
                                isActive: 1,
                                isFilter: false,
                                with:100,
                                thStyle: "width:100px",
                                sorting: false,
                            },
                    ]
                },
                tableItems: [],
                modals:{
                },
                timer: {
                    save: null,
                    contracts: null
                },
                images: [],
            }
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID'
            })
        },
        watch: {},
        created() {
            this.getContracts()
        },
        methods:{
            /*-- Gofix Table --------*/
            async getTableData(callback) {
                const { tableRequest , resolve,reject } = await callback();
                await this.$store.dispatch("NLTReportController/getItems", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => {
                    console.log(err);
                    this.$alertNotification("Can not load the items", "danger");
                    reject();
                })
            },

            /*-- Get Data --------*/
            async getContracts(filter = null) {
                await this.$store.dispatch('ContractController/getListClientContractsSearch', [1, filter, 1000])
                .then(response => {  
                    this.modals.addressBook.options.contracts = response.data; 
                }).catch(error => {
                    console.log(error);
                })
            },
            searchContract(search, loading){
                this.modals.addressBook.options.contracts = []
                loading(true);
                if(this.timer.contracts) {
                    clearTimeout(this.timer.contracts);
                    this.timer = null;
                }
                this.timer.contracts = setTimeout(async () => {
                    try {
                        await this.getContracts({ contract_name: search });
                        await loading(false);
                    } catch (err) {
                        loading(false);
                    }
                }, 500);
            },
            async previewFile(attachment) {
                if(attachment.image_content_type && 
                   (attachment.image_content_type.includes('image') ||
                    attachment.image_content_type.includes('pdf')
                )
                ){
                    const link = document.createElement('a');
                    var path = this.$router.resolve({name: 'FilePreview', params: {file_id: attachment.id}}).href;
                    link.href= path;
                    link.setAttribute('target', '_blank');
                    document.body.appendChild(link);
                    link.click();
                }
                else{
                    await this.downloadAttachment(attachment);
                }
            },
            async downloadAttachment(item){
                        let url = item.url.original;
                        let params = {};
                        params.url = url;
                        params.image_file_name = item.image_file_name;

                        await this.$store.dispatch("FileDownloadController/getFile", params)
                        .then(response => {
                        })
                        .catch(err => {
                            this.$alertNotification("Can not download file", "danger");
                            console.log(err);
                        });
                    
                    return this.$alertNotification("Download attachment successfully!");
                
            },
            doThisImages: function (attachments) {
                this.images = attachments
            },
        }
    }
</script>